module.exports = __webpack_public_path__ + "static/media/posterNew.de3b4c4e.jpeg";